// extracted by mini-css-extract-plugin
export default {"link":"AloneLogoTop_link__LuWLg","logo":"AloneLogoTop_logo__JNcmP"};